import type { CartUpsellButtonLabels } from '@/components/CheckoutSummary/types'

import type { CheckoutCartUpsell } from '@VelocitySquared/sunny16-content-dataobjects-cady/booking'

// =========================================
// Button labels (UI chrome, not CMS content)
// =========================================

export const cartUpsellButtonLabels: CartUpsellButtonLabels = {
  addedToCart: 'Added to Cart',
  addToCart: 'Add to Cart',
  noThankYou: 'No Thanks'
}

// =========================================
// CMS-typed fallback keyed by API bundle identifier
// =========================================

export const cartUpsellFallbacks: Record<string, CheckoutCartUpsell> = {
  BOOKING_ARTISTTOUCH: {
    internalName: '',
    identifier: '',
    heading: '',
    subtitle: '',
    body: '',
    featureItems: [],
    ctaLabel: '',
    image: { assetId: '', alt: '', width: 0, height: 0, url: '' },
    variant: ''
  } as unknown as CheckoutCartUpsell,
  BW_PROOFS: {
    internalName: '',
    identifier: '',
    heading: '',
    subtitle: '',
    body: '',
    featureItems: [],
    ctaLabel: '',
    image: { assetId: '', alt: '', width: 0, height: 0, url: '' },
    variant: ''
  } as unknown as CheckoutCartUpsell
}
